"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var VCWrapperComponent = /** @class */ (function () {
    function VCWrapperComponent(route) {
        this.route = route;
        this.logoSrc = 'icons/shell-logo.png';
        this.hasJoined = false;
        this.isEnded = false;
        this.isLeft = false;
        this.isBlocked = false;
        this.isSubscriber = false;
        this.leave = new core_1.EventEmitter();
        this.end = new core_1.EventEmitter();
    }
    VCWrapperComponent.prototype.ngOnInit = function () {
        this.isSubscriber = this.route.snapshot.queryParams.isSubscriber;
        this.hasJoined = this.isSubscriber;
        this.isAlreadyStarted = this.route.snapshot.queryParams.isAlreadyStarted;
    };
    VCWrapperComponent.prototype.onJoin = function (event) {
        this.hasJoined = event;
    };
    VCWrapperComponent.prototype.onLeave = function () {
        this.isLeft = true;
        this.hasJoined = false;
        this.leave.emit();
    };
    VCWrapperComponent.prototype.onEnd = function () {
        this.isEnded = true;
        this.hasJoined = false;
        this.end.emit();
    };
    VCWrapperComponent.prototype.rejoin = function () {
        this.isLeft = false;
        this.hasJoined = false;
    };
    VCWrapperComponent.prototype.onBlock = function () {
        this.isBlocked = true;
        this.hasJoined = false;
    };
    VCWrapperComponent.prototype.joinIfStarted = function () {
        this.isAlreadyStarted = false;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VCWrapperComponent.prototype, "sessionId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VCWrapperComponent.prototype, "logoSrc", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.TemplateRef)
    ], VCWrapperComponent.prototype, "headerTemplate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VCWrapperComponent.prototype, "leave", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VCWrapperComponent.prototype, "end", void 0);
    VCWrapperComponent = __decorate([
        core_1.Component({
            selector: 'sis-vc-wrapper',
            template: require('./vc-wrapper.component.html'),
            styles: [require('./vc-wrapper.component.css')]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute])
    ], VCWrapperComponent);
    return VCWrapperComponent;
}());
exports.VCWrapperComponent = VCWrapperComponent;
//# sourceMappingURL=vc-wrapper.component.js.map